import {BI_SCHEMA} from './services/biLogger/biEvents';
import {createMusicLogger} from './services/biLogger/createMusicLogger';
import {getAlbumAndTrackId} from './services/env/getAlbumAndTrackId/getAlbumAndTrackId';

const {albumId} = getAlbumAndTrackId(location.search, location.hash);
const logger = createMusicLogger(albumId);

logger.log(BI_SCHEMA.player.downloadPage['pre-opened']);
